import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateScheduledCallback } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { selectScheduledCallbackForm } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'

const useScheduleCallbackValidation = () => {
  const dispatch = useDispatch()
  const { firstName, lastName, phone, scheduledDate, hour, minutes, businessVertical } =
    useSelector(selectScheduledCallbackForm)

  useEffect(() => {
    const selectedDate = scheduledDate ? new Date(scheduledDate) : null
    const isDateValid = selectedDate instanceof Date && !Number.isNaN(selectedDate?.getTime())
    const hasHourAndMinute = !!hour && !!minutes

    let notInPast = true
    if (isDateValid && hasHourAndMinute) {
      const when = new Date(selectedDate)
      when.setHours(parseInt(hour, 10), parseInt(minutes, 10), 0, 0)
      notInPast = when.getTime() >= Date.now()
    }

    const isValid =
      (firstName || '').trim() &&
      (lastName || '').trim() &&
      (phone || '').trim() &&
      (businessVertical || '').trim() &&
      isDateValid &&
      hasHourAndMinute &&
      notInPast

    dispatch(updateScheduledCallback({ form: { isValid } }))
  }, [firstName, lastName, phone, scheduledDate, hour, minutes, businessVertical])
}

export default useScheduleCallbackValidation
